import { render, staticRenderFns } from "./feature_library_item.vue.js?vue&type=template&id=816327fe!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./feature_library_item.vue?vue&type=template&id=816327fe"
import script from "./feature_library_item.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./feature_library_item.vue?vue&type=script&lang=js"
export * from "./feature_library_item.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./feature_library_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('816327fe')) {
      api.createRecord('816327fe', component.options)
    } else {
      api.reload('816327fe', component.options)
    }
    module.hot.accept("./feature_library_item.vue.js?vue&type=template&id=816327fe!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./feature_library_item.vue?vue&type=template&id=816327fe", function () {
      api.rerender('816327fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "super_sidebar/components/feature_library/feature_library_item.vue"
export default component.exports